module.exports = __webpack_public_path__ + "img/L6.5b7bca05.png";